export enum CardAnimate {
    TOP = 'card-animate-from-top',
    BOTTOM = 'card-animate-from-bottom',
    SIMPLE = 'card-animate-simple',
    SLIDE_TOP = 'card-animate-slide-from-top',
    SLIDE_BOTTOM = 'card-animate-slide-from-bottom',
    DISABLED = 'card-animate-disabled',
}
